import { css } from '@emotion/react'
import { Cell, Grid } from 'bold-ui'
import { TextAreaField } from 'components/form'
import { ReactComponent as EarIcon } from 'images/antropometria/ear.svg'
import { ReactComponent as BicepsIcon } from 'images/antropometria/flexed-biceps-outline.svg'
import { ReactComponent as SkinIcon } from 'images/antropometria/skin-outline.svg'
import { Fragment } from 'react'
import { MetaPath } from 'util/metaPath'

import { AntropometriaAccordionModel } from './AntropometriaAccordion'
import { AntropometriaGridItem } from './AntropometriaGridItem'
import { ForcaMuscularMaoField } from './ForcaMuscularMaoField'

interface PacMedicoesFieldProps {
  name: MetaPath<AntropometriaAccordionModel>
}

export function PacMedicoesField(props: Readonly<PacMedicoesFieldProps>) {
  const { name } = props

  return (
    <Fragment>
      <AntropometriaGridItem icon={<SkinIcon />} titulo='Pele'>
        <Cell size={12} alignSelf='center'>
          <TextAreaField
            name={name.pele}
            label='Observações'
            placeholder='Insira informações sobre a pele'
            maxLength={300}
            resize='vertical'
          />
        </Cell>
      </AntropometriaGridItem>
      <AntropometriaGridItem iconName='eyeOutline' titulo='Olhos'>
        <Cell size={6}>
          <TextAreaField
            name={name.olhoDireito}
            label='Olho direito'
            placeholder='Insira informações sobre o olho direito, como exames realizados'
            maxLength={250}
            resize='vertical'
            style={styles.textArea}
          />
        </Cell>
        <Cell size={6}>
          <TextAreaField
            name={name.olhoEsquerdo}
            label='Olho esquerdo'
            placeholder='Insira informações sobre o olho esquerdo, como exames realizados'
            maxLength={250}
            resize='vertical'
            style={styles.textArea}
          />
        </Cell>
      </AntropometriaGridItem>
      <AntropometriaGridItem icon={<EarIcon />} titulo='Ouvidos'>
        <Cell size={6}>
          <TextAreaField
            name={name.ouvidoDireito}
            label='Ouvido direito'
            placeholder='Insira informações sobre o ouvido direito, como exames realizados'
            maxLength={250}
            resize='vertical'
            style={styles.textArea}
          />
        </Cell>
        <Cell size={6}>
          <TextAreaField
            name={name.ouvidoEsquerdo}
            label='Ouvido esquerdo'
            placeholder='Insira informações sobre o ouvido esquerdo, como exames realizados'
            maxLength={250}
            resize='vertical'
            style={styles.textArea}
          />
        </Cell>
      </AntropometriaGridItem>
      <AntropometriaGridItem icon={<BicepsIcon />} titulo='Avaliação de força muscular'>
        <Grid gap={2} alignItems='flex-start' style={{ padding: '0.5rem' }}>
          <Cell size={5}>
            <ForcaMuscularMaoField
              name={{ valor: name.valorForcaMuscMaoDireita, unidade: name.unidadeForcaMuscMaoDireita }}
              label={{
                valor: 'Mão direita',
                unidade: 'Unidade de medida',
              }}
            />
          </Cell>
          <Cell size={5}>
            <ForcaMuscularMaoField
              name={{ valor: name.valorForcaMuscMaoEsquerda, unidade: name.unidadeForcaMuscMaoEsquerda }}
              label={{
                valor: 'Mão esquerda',
                unidade: 'Unidade de medida',
              }}
            />
          </Cell>
        </Grid>
      </AntropometriaGridItem>
    </Fragment>
  )
}

const styles = {
  textArea: css`
    height: 8.5rem;
  `,
}
